import React from 'react'
import { useVersionCheck } from '../hooks/useVersionCheck'

const NewVersionBanner: React.FC = () => {
  const { newVersionAvailable, reload } = useVersionCheck()
  if (!newVersionAvailable) return null
  return (
    <div
      role='status'
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 11000,
        background: '#0d3b66',
        color: '#ffffff',
        borderRadius: 12,
        padding: '14px 18px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        maxWidth: 360,
        fontSize: 14,
      }}
    >
      <span>Ny versjon tilgjengelig.</span>
      <button
        type='button'
        onClick={reload}
        className='btn btn-sm btn-light'
        style={{ fontWeight: 600 }}
      >
        Last inn på nytt
      </button>
    </div>
  )
}

export default NewVersionBanner
